import { sendWebexEvent } from '@klv/context/experimentation/utils';
import type { IInitialFormValues, TFormType } from '../types';

const handleSuccess = (values: IInitialFormValues, form: TFormType) => {
  window?.heap?.track?.('Marketing Form Success', {
    emailAddress: values?.email ?? '',
    formName: form,
    host: process.env.GATSBY_HOST ?? '',
  });

  if (form === 'demo') {
    sendWebexEvent('global_conversion_get_a_demo_eng');
  } else if (form === 'signup') {
    sendWebexEvent('global_conversion_sign_up_eng');
  }
};

export default handleSuccess;
